// import service from "@/utils/service";
import service from "@/service/service2";

export const publicStsToken = (data) => service.get("/public/sts/token", data);
